import artifact from '$houdini/artifacts/CreateInventoryType'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateInventoryTypeStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
